import { Component, input } from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";
import { DirectusTranslationPipe } from "../../../common/pipes/directus-translation.pipe";
import { ItemsPackages } from "../../api/packbo/models/items-packages";

@Component({
    selector: "packbo-package-badge",
    templateUrl: "./package-badge.template.html",
    imports: [SvgIconComponent, DirectusTranslationPipe]
})
export class PackageBadgeComponent {
    public readonly package = input<ItemsPackages | null>();
    public readonly prefix = input<string>("");
}
